export default __webpack_public_path__ + "static/media/wave-blob.6920aa9a.gif";